import SearchRequest from "@wwdev/product/SearchRequest";
SearchRequest.setPage = function(page) {
	this.request.pageID = page;
}
